// src/components/ui/Tabs.js
import React from 'react';
import './ui.css';

const Tabs = ({ 
  options = [], 
  activeTab, 
  onChange, 
  handleVoiceClick, 
  voiceMessages = {}, 
  className = '',
  style = {}
}) => {
  return (
    <div 
      className={`ultra-clean-scroll ${className}`}
      style={{
        display: 'flex',
        background: 'rgba(255, 255, 255, 0.4)',
        border: '1px solid rgba(15, 23, 42, 0.05)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: '16px',
        padding: '4px',
        gap: '4px',
        overflowX: 'auto',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        width: '100%',
        boxSizing: 'border-box',
        ...style
      }}
    >
      {options.map((option) => {
        const isActive = activeTab === option.key;
        const currentVoiceMsg = voiceMessages[option.key] || `ये ${option.label} बटन है।`;

        return (
          <button
            key={option.key}
            type="button"
            className="micro-click-pill"
            onClick={(e) => {
              if (handleVoiceClick) {
                handleVoiceClick(
                  e, 
                  `ये ${option.label} बटन है, देखने के लिए दोबारा क्लिक करें।`, 
                  () => onChange(option.key),
                  `tab-trigger-${option.key}`,
                  isActive,
                  currentVoiceMsg
                );
              } else {
                onChange(option.key);
              }
            }}
            style={{
              flex: 1,
              minWidth: '80px',
              padding: '10px 6px',
              borderRadius: '12px',
              background: isActive ? '#FFFFFF' : 'transparent',
              color: isActive ? '#0F172A' : '#64748B',
              border: isActive ? 'none' : '1px solid transparent',
              boxShadow: isActive ? '0 4px 12px rgba(15, 23, 42, 0.05)' : 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.25s cubic-bezier(0.16, 1, 0.3, 1)',
              outline: 'none',
              fontFamily: "'Plus Jakarta Sans', sans-serif"
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
              <span style={{ fontSize: '11px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                {option.label}
              </span>
              
              {option.isLive && (
                <span style={{ 
                  fontSize: '7px', 
                  background: isActive ? '#10B981' : '#E2E8F0', 
                  color: isActive ? '#FFFFFF' : '#64748B', 
                  padding: '1.5px 5px', 
                  borderRadius: '6px', 
                  fontWeight: '900',
                  boxShadow: isActive ? '0 2px 6px rgba(16, 185, 129, 0.3)' : 'none'
                }}>
                  LIVE
                </span>
              )}
            </div>
            {option.subLabel && (
              <span style={{ fontSize: '9px', fontWeight: '600', marginTop: '2px', opacity: isActive ? 0.8 : 0.55 }}>
                {option.subLabel}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;